import { render } from "./PostToComment.vue?vue&type=template&id=0cfa9e8c"
import script from "./PostToComment.vue?vue&type=script&lang=js"
export * from "./PostToComment.vue?vue&type=script&lang=js"

import "./PostToComment.vue?vue&type=style&index=0&id=0cfa9e8c&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__